export const globalTemplateOptions = [
  {
    key: 'global-template-false',
    value: false,
    text: 'Keep it only for myself',
  },
  { key: 'global-template-true', value: true, text: 'Share it  with everyone' },
];

export const formName = 'new-plan';
